import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  Popover,
} from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as moment from "moment";
import * as React from "react";
import { api_adm } from "../../api";
import { IConta, newFilterContas } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { ContaStore } from "../../stores/admin/ContaStore";
import { ContaDialog } from "./ContaDialog";
import { toast } from "react-toastify";
import { formatCnpj } from "../../utils";
import { PagerResultados } from "../utils/PagerResultados";
import { IconButton } from "@mui/material";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";

var debounce = require('lodash.debounce');

const numeral = require("numeral");

interface ContasPageProps {
}

interface ContasPageState {
}

@observer
export class ContasPage
  extends React.Component<ContasPageProps, ContasPageState> {
  obs = observable({
    currentPage: 1 as number,
    editing: null as IConta,
    viewConta: false as boolean,
    viewLogs: false as boolean,
    open_editing: false as boolean,
    open_filters: false as boolean,
    fetchOptions: {} as any
  })

  async componentDidMount() {
    AppStore.setTitle("Contas");

    ContaStore.obs.filters = newFilterContas()

    await ContaStore.loadContas(1);

    this.obs.fetchOptions = debounce(this.handlePageChange.bind(this), 800);

  }

  handleAdd = () => {
    this.obs.editing = {
      nome: "",
      cnpj: "",
      saldo: 0,
      ativo: true,
      qtd_cnpj_normal: 0,
      qtd_cnpj_simples: 0,
      qtd_cnpj_normal_em_uso: 0,
      qtd_cnpj_simples_em_uso: 0,
      status_pagamento: "Pendente",
      usuarios: [],
      autenticacao: "SMS",
      notificacao: false,
      desconto: 0,
    };

    ContaStore.obs.empresas_planos_personalizados = []
    ContaStore.obs.empresas_planos = []

    this.obs.open_editing = true

  };

  handleEditConta = async (conta) => {
    this.obs.editing = conta;

    ContaStore.obs.conta_id = conta._id

    await ContaStore.getContaPlano(conta._id);

    this.obs.open_editing = true

  };

  handleEditClose = async () => {

    this.obs.open_editing = false

    ContaStore.obs.conta_id = ""
    this.obs.editing = null;

    this.obs.currentPage = 1

    await ContaStore.loadContas(1);

  };

  handleViewLog = (id: any) => {
    ContaStore.getContaLogs(id);
    this.obs.viewLogs = true;
  };

  async handleDeleteConta(conta: IConta & IViewModel<IConta>): Promise<void> {

    ContaStore.obs.progressDelete = true;

    try {

      let resp = await api_adm.delete(`/api/admin/contas/${conta._id}`);

      if (resp.data == "finalizado") {

        await ContaStore.loadContas(1);

      }

      else {
        toast.error('Não foi possível deletar a conta, tente novamente mais tarde.', {});
      }

    } catch (ex) {
      toast.error('Erro ao deletar a conta!', {});
    }

    ContaStore.obs.progressDelete = false;

  }

  handleSetFilter = async (text: any) => {

    this.obs.currentPage = 1;

    ContaStore.obs.filters.filter = text

    this.obs.fetchOptions(1)

  };

  handlePageChange = async (page: number): Promise<void> => {

    this.obs.currentPage = page

    await ContaStore.loadContas(page);

  };

  handleBuscaContas = async (e: any) => {

    this.obs.currentPage = 1;

    await ContaStore.loadContas(1);

  };

  handleCleanFilters = async () => {

    ContaStore.obs.filters = newFilterContas()

    this.obs.currentPage = 1;

    await ContaStore.loadContas(1);

  };

  render() {

    const format_date = (data_fatura) => {

      if (!data_fatura) return

      const dataFatura = new Date(data_fatura)
      const hoje = new Date();

      dataFatura.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);

      return Math.ceil((dataFatura.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));

    }

    let items = ContaStore.obs.contas?.map((conta: any) => {

      if (!conta.iugu_fatura) {
        conta.iugu_fatura = {};
      }

      const diasParaVencimento = format_date(conta.iugu_fatura["data_fatura"])

      return (
        <tr key={conta._id}>
          <td>{conta.razao_social}</td>
          <td>{conta.nome}</td>
          <td>{formatCnpj(conta.cnpj || "")}</td>
          <td>{moment(conta.inserted_at || "null").format("DD/MM/YYYY")}</td>
          <td>
            {conta.ativo
              ? (
                <span style={{ color: "green", letterSpacing: "0.03em" }}>
                  Ativada
                </span>
              )
              : (
                <span style={{ color: "red", letterSpacing: "0.03em" }}>
                  Desativada
                </span>
              )}
          </td>
          <td>{conta.id_assinatura ?
            <span style={{ color: "green", letterSpacing: "0.03em" }}>
              Assinatura realizada
            </span>
            :
            <span style={{ color: "orange", letterSpacing: "0.03em" }}>
              Sem assinatura
            </span>
          }</td>
          <td>
            {conta.iugu_fatura["status"] == "paid"
              ? (
                <span style={{ color: "green", letterSpacing: "0.03em" }}>
                  Fatura paga
                </span>
              )
              : conta.iugu_fatura["status"] == "externally_paid"
                ? (
                  <span style={{ color: "green", letterSpacing: "0.03em" }}>
                    Fatura paga
                  </span>
                )
                : conta.iugu_fatura["status"] == "pending"
                  ? (
                    <span style={{ color: "orange", letterSpacing: "0.03em" }}>
                      Pendente
                    </span>
                  )
                  : conta.iugu_fatura["status"] == "draft"
                    ? (
                      <span style={{ color: "gray", letterSpacing: "0.03em" }}>
                        Fatura não gerada
                      </span>
                    )
                    : conta.iugu_fatura["status"] == "expired"
                      ? (
                        <span style={{ color: "red", letterSpacing: "0.03em" }}>
                          Fatura expirada
                        </span>
                      )
                      : (
                        <span style={{ color: "darkgray", letterSpacing: "0.03em" }}>
                          Sem fatura
                        </span>
                      )}
          </td>
          <td>{conta.iugu_fatura["valor_pago"] || "R$ 0,00"}</td>
          <td style={{ letterSpacing: "0.03em", color: diasParaVencimento < 0 ? "red" : diasParaVencimento <= 3 ? "orange" : "green" }}>{conta.iugu_fatura["data_fatura"] ? moment(conta.iugu_fatura["data_fatura"]).format("DD/MM/YYYY") : ""}</td>
          <td className="nz-table-actions">
            {/* <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={() => this.handleViewLog(conta._id)}
            >
              <img src="/images/files.png" width={25} />
            </MDBBtn>
            &nbsp; */}
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={() => this.handleEditConta(conta)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            &nbsp;
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Todos os dados vinculados a conta serão excluídos TODOS</p>
                <p>Confirmar exclusão da conta?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDeleteConta.bind(this, conta)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    let empresas = ContaStore.obs.empresas?.map(emp => {
      return (
        <tr key={emp.cnpj}>
          <td>{emp.nome.substring(0, 40)}</td>
          <td>R$ {numeral(emp.calculado).format("0,0.00")}</td>
          <td>{emp.nfes}</td>
          <td>{emp.armazenamento} Gb</td>
        </tr>
      );
    });

    let logs = ContaStore.obs.logs?.map(log => {
      return (
        <MDBCol md="12" key={log.id}>
          <div className="temp-nfes-manif bloco-background">
            <p>
              <span>{log.texto}</span> <br />
              <b>Usuário: {log.usuario}</b> <br />
              <b>Data de Aceite: {moment(log.inserido).format("DD/MM/YYYY")}</b>
              <b>IP: {log.ip}</b> <br />
            </p>
          </div>
        </MDBCol>
      );
    });

    return (
      <div>
        <Dialog
          isOpen={this.obs.viewConta}
          onClose={() => this.obs.viewConta = false}
          title={"Informações de " + ContaStore.obs.nome_conta}
          className="dialogContaView"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="7">
                <div className="temp-nfes-manif">
                  <p>
                    <img
                      src="/images/ciencia.png"
                      width="25px;"
                      className="icon-bloco"
                    />
                    <span>Cálculo Processado</span>
                    <b>
                      R${" "}
                      {numeral(ContaStore.obs.calculo_processado).format("0,0.00")}
                    </b>
                  </p>
                </div>
              </MDBCol>
              <MDBCol md="5" className="temp-men">
                <div className="temp-nfes-manif">
                  <p>
                    <img
                      src="/images/ciencia.png"
                      width="25px;"
                      className="icon-bloco"
                    />
                    <span>NF-es Calc.</span>
                    <b>{ContaStore.obs.nfes}</b>
                  </p>
                </div>
              </MDBCol>
              <MDBCol md="7">
                <div className="temp-nfes-manif">
                  <p>
                    <img
                      src="/images/ciencia.png"
                      width="25px;"
                      className="icon-bloco"
                    />
                    <span>Nf-es Manifestadas</span>
                    <b>{ContaStore.obs.total_manifestado}</b>
                  </p>
                </div>
              </MDBCol>
              <MDBCol md="5" className="temp-men">
                <div className="temp-nfes-manif">
                  <p>
                    <img
                      src="/images/ciencia.png"
                      width="25px;"
                      className="icon-bloco"
                    />
                    <span>Empresas</span>
                    <b>{ContaStore.obs.total_empresas}</b>
                  </p>
                </div>
              </MDBCol>
              <MDBCol md="12">
                <div className="dadosTotaisConta">
                  <span className="block-t-c">
                    <b>{ContaStore.obs.usuarios}</b> Usuários
                    <img src="images/correct.svg" width={20} />
                  </span>
                  <span className="block-t-c">
                    <b>{ContaStore.obs.total_espaco} Gb</b> Armazenado
                    <img src="images/correct.svg" width={20} />
                  </span>
                </div>
              </MDBCol>
              <MDBCol md="12">
                <div className="TableDefault">
                  <HTMLTable
                    className="table table-hover dataTable"
                    style={{ width: "100%", marginTop: 15 }}
                    small
                  >
                    <thead>
                      <tr>
                        <th>Empresa</th>
                        <th style={{ width: 140 }}>Calculado</th>
                        <th style={{ width: 150 }}>Qty NF-es</th>
                        <th style={{ width: 150 }}>Armaz.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {empresas}
                    </tbody>
                  </HTMLTable>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.obs.viewLogs}
          onClose={() => this.obs.viewLogs = false}
          title={"Logs de " + ContaStore.obs.nome_conta}
          className="dialogContaView"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              {logs}
            </MDBRow>
          </div>
        </Dialog>

        <LoadingModal open={ContaStore.obs.progressDelete} onClose={() => ContaStore.obs.progressDelete = false} title={"Deletando conta"} />

        <div style={{ display: "flex" }}>
          <InputGroup
            style={{ width: 400, marginRight: 10 }}
            placeholder="Filtrar (Razão Social, Nome, CNPJ, ID)"
            value={ContaStore.obs.filters.filter}
            onChange={(e) => this.handleSetFilter(e.target.value)}
          />

          <IconButton onClick={() => this.obs.open_filters = !this.obs.open_filters}>
            <AppIcon name="filter_list" />
          </IconButton>
        </div>

        {this.obs.open_filters &&
          <>

            <br />

            <div style={{ border: "1px solid rgba(0, 0, 0, .1)", padding: 10, borderRadius: 10, float: "right", width: "100%", marginBottom: 20 }}>

              <div style={{ display: "flex" }}>
                <FormGroup
                  style={{ width: "20%", marginRight: 10 }}
                  label="Status Conta">
                  <HTMLSelect
                    className='select-group-prospeccao select-group-prospeccao-modal'
                    onChange={async (e) => this.handleBuscaContas(ContaStore.obs.filters.conta = e.target.value)}
                    value={ContaStore.obs.filters.conta}>
                    <option value="">Selecione</option>
                    <option value="desativada">Desativadas</option>
                    <option value="ativada">Ativas</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  style={{ width: "20%", marginRight: 10 }}
                  label="Status Assinatura">
                  <HTMLSelect
                    className='select-group-prospeccao select-group-prospeccao-modal'
                    onChange={async (e) => this.handleBuscaContas(ContaStore.obs.filters.assinatura = e.target.value)}
                    value={ContaStore.obs.filters.assinatura}>
                    <option value="">Selecione</option>
                    <option value="sem_assinatura">Sem assinatura</option>
                    <option value="assinatura">Assinatura realizada</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  style={{ width: "20%", marginRight: 10 }}
                  label="Status Fatura">
                  <HTMLSelect
                    className='select-group-prospeccao select-group-prospeccao-modal'
                    onChange={async (e) => this.handleBuscaContas(ContaStore.obs.filters.fatura = e.target.value)}
                    value={ContaStore.obs.filters.fatura}>
                    <option value="">Selecione</option>
                    <option value="sem_fatura">Sem fatura</option>
                    <option value="pagas">Fatura paga</option>
                    <option value="inadimplentes">Fatura expirada</option>
                    <option value="pendentes">Pendente</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup style={{ width: "20%" }}>
                  <MDBBtn
                    className="btnDefault btnBuscarNfe"
                    onClick={(e) => this.handleCleanFilters()} style={{ marginTop: 28 }}>
                    Limpar Filtro
                  </MDBBtn>
                </FormGroup>

              </div>
            </div>
          </>
        }

        <br />

        <FormGroup className="TableContas">
          <HTMLTable className="table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: 400 }}>Razão Social</th>
                <th style={{ width: 400 }}>Nome</th>
                <th style={{ width: 150 }}>CNPJ</th>
                <th style={{ width: 150 }}>Data Cadastro</th>
                <th style={{ width: 150 }}>Status Conta</th>
                <th style={{ width: 200 }}>Status Assina.</th>
                <th style={{ width: 150 }}>Status Fatura</th>
                <th style={{ width: 150 }}>Valor Fatura</th>
                <th style={{ width: 150 }}>Data Fatura</th>
                <th style={{ width: 150 }} />
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>
        </FormGroup>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <PagerResultados
            currentPage={this.obs.currentPage}
            totalCount={ContaStore.obs.contas.length}
            pageSize={15}
            onPageChange={this.handlePageChange}
          />
        </div>

        {this.obs.open_editing && (
          <ContaDialog conta={this.obs.editing} onClose={this.handleEditClose} />
        )}
      </div>
    );
  }
}

export default ContasPage;

